import { useState } from "react";
import { reviews } from "@/mocks/gossipData";

const tags = ["敢于说话", "有笑有料", "理性吃瓜"];

export default function Reviews() {
  const [liked, setLiked] = useState<number[]>([]);
  const toggleLike = (i: number) =>
    setLiked((prev) => (prev.includes(i) ? prev.filter((x) => x !== i) : [...prev, i]));

  return (
    <section id="reviews" className="bg-background-100/70 py-14 md:py-20">
      <div className="wrap">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="mb-2 text-xs font-bold uppercase tracking-widest text-primary-600">HOT TAKES</p>
            <h2 className="font-display text-2xl font-black text-foreground-950 md:text-4xl">网友辣评</h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600">
              好的吃瓜氛围需要一起维护。看看大家怎么想，也欢迎点亮你认同的那一条。
            </p>
          </div>
          <ul className="flex flex-wrap gap-2">
            {tags.map((t) => (
              <li
                key={t}
                className="whitespace-nowrap rounded-full bg-accent-100 px-3.5 py-1.5 text-xs font-bold text-accent-800"
              >
                {t}
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r, i) => (
            <figure key={r.name} className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-6">
              <div className="flex items-center justify-between">
                <figcaption className="flex items-center gap-3">
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-black text-background-50 ${
                      i % 3 === 0 ? "bg-primary-500" : i % 3 === 1 ? "bg-accent-600" : "bg-secondary-500"
                    }`}
                  >
                    {r.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-900">{r.name}</p>
                    <p className="text-xs text-foreground-400">{r.time}</p>
                  </div>
                </figcaption>
                <i className="ri-double-quotes-l text-2xl text-primary-200"></i>
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">{r.text}</blockquote>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-heart-3-line"></i>
                  {r.likes} 条赞
                </span>
                <button
                  type="button"
                  onClick={() => toggleLike(i)}
                  aria-pressed={liked.includes(i)}
                  aria-label="点亮这条评论"
                  className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-bold transition ${
                    liked.includes(i)
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
                  }`}
                >
                  <i className={liked.includes(i) ? "ri-thumb-up-fill" : "ri-thumb-up-line"}></i>
                  {liked.includes(i) ? "已点亮" : "认同"}
                </button>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}